/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Title_TailInputs */

const en_for_whom_title_tail = /** @type {(inputs: For_Whom_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your specialist.`)
};

const pl_for_whom_title_tail = /** @type {(inputs: For_Whom_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój specjalista.`)
};

/**
* | output |
* | --- |
* | "Your specialist." |
*
* @param {For_Whom_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_title_tail = /** @type {((inputs?: For_Whom_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_title_tail(inputs)
	return en_for_whom_title_tail(inputs)
});